// extracted by mini-css-extract-plugin
export var dateLabel = "_2k-0";
export var dateLabelError = "_2k-1";
export var fullWidth = "_2k-2";
export var smaller = "_2k-3";